import { Injectable } from '@angular/core';
import {DataLayer} from 'src/app/models/analytics/analytics.data-layer';

declare const _satellite: any;
declare const dataLayer: DataLayer;
@Injectable({
  providedIn: 'root'
})
export class AdobeAnalyticsService {
  triggerAppStartEvent() {
    try {
      dataLayer.application.applicationStep = 'Step 1';
      dataLayer.application.applicationName = 'Zmbizi';
      
      _satellite.track('globalApplicationStart');
    } catch (_error) {
      console.error(_error.message)
    }
  }

  triggerFormStart(formName: string) {
    try {
      dataLayer.formName = formName;
      dataLayer.application.applicationStep = '';
      dataLayer.formisSubmitted = false;
      dataLayer.formStatus = "";
  
      _satellite.track('globalFormStart');
    } catch (_error) {
      console.error(_error.message)
    }
  }
  triggerFormComplete(formName: string) {
    try {
      dataLayer.formName = formName;
      dataLayer.formisSubmitted = true;
      dataLayer.formStatus = "complete";

      _satellite.track('globalFormComplete');
    } catch (_error) {
      console.error(_error.message)
    }
  }

  triggerSiteError(errorCode: string, reason: string, request: string) {
    errorCode = errorCode ? errorCode : '500';
    reason = reason ? reason : 'unknown';

    if (errorCode != '200') {
      try {
        dataLayer.siteErrorCode = errorCode + ' | ' + reason + ' | ' + request;
        _satellite.track('sendSiteErrorCode');
      } catch (_error) {
        console.error(_error.message)
      }
    }
  }

  triggerPageViewEvent(pageName: string) {
    try {
      dataLayer.pageName = pageName;
      _satellite.track('globalVirtualPageView');
    } catch (_error) {
      console.error(_error.message)
    }
  }

  triggerAppCompleteEvent() {
    try {
      dataLayer.application.applicationStep = '';
      dataLayer.application.applicationName = 'Zmbizi';
      
      _satellite.track('globalApplicationComplete');
    } catch (_error) {
      console.error(_error.message)
    }
  }


}
